import axios from "axios";

const CMS_BASE_URL = `${process.env.REACT_APP_CMS_BASEURL}`;
// const LUNG_CARE_API_URL = `${process.env.REACT_APP_LUNGSCARE}`;

export function getDietMainData() {


  return axios.get(`${CMS_BASE_URL}ai-diets?populate=first,third,third.thirdsub,fourth,fourth.fourthsub,fifth,fifth.fifthsub,sixth,sixth.sixthsub`, 
  );
 
 
}
